var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Error / Filled / 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6lxq6x5n7a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4074",
    d: "M218-1441a8.963 8.963 0 0 0-9 9 8.963 8.963 0 0 0 9 9 8.963 8.963 0 0 0 9-9 8.963 8.963 0 0 0-9-9zm3.5 13.5-8-8 1-1 8 8z",
    style: {
      clipRule: "evenodd",
      fill: "#e32a34"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "elyy0q7gfb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4073",
    d: "M192-1408h672v-48H192z",
    style: {
      fill: "#e32a34"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4042",
    transform: "translate(-209 1441)",
    style: {
      clipPath: "url(#6lxq6x5n7a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4041",
    style: {
      clipPath: "url(#elyy0q7gfb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4072",
    d: "M204-1446h28v28h-28z",
    style: {
      fill: "#e32a34"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/Error-Icon.e162148bf09b40ea7c22f717c2d84e35.svg";
export { ForwardRef as ReactComponent };